<template>
  <v-card-text
    class="pa-0"
  >
    <v-col class="text-right py-0">
      <v-btn
          tail
          text
          color="green"
          @click.prevent="openActionApprover()"
      >
          {{$t("views.approveList.action.approver")}}
      </v-btn>
      <v-btn
          tail
          text
          color="red"
          @click.prevent="openActionReject()"
      >
          {{$t("views.approveList.action.reject")}}
      </v-btn>
      <Approve
          v-show="openApprover"
          :ticket="ticket"
          @refresh:detail="closeActions()"
          @input="openActionApprover()"
      >
      </Approve>
      <Reject
          v-show="openReject"
          :ticket="ticket"
          @refresh:detail="closeActions()"
          @input="openActionReject()"
      >
      </Reject>
    </v-col>
  </v-card-text>
</template>
<script>

export default {
  components: {
    Approve: () => import(/* webpackChunkName: "approvalsList" */ '@/components/ticket-actions/Approve.vue'),
    Reject: () => import(/* webpackChunkName: "approvalsList" */ '@/components/ticket-actions/Reject.vue'),
  },
  props: {
    ticket: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openApprover: false,
      openReject: false,
    };
  },
  methods: {
    openActionApprover() {
      if (this.openReject) {
        this.openReject = false;
      }
      this.openApprover = !this.openApprover;
    },
    openActionReject() {
      if (this.openApprover) {
        this.openApprover = false;
      }
      this.openReject = !this.openReject;
    },
    closeActions() {
      this.openApprover = false;
      this.openReject = false;
      this.$emit('refresh:list');
    },
  },
};

</script>
